import type { Ref } from "vue";
import type { Manifest } from "@readium/shared";
import { mediaOverlayResource, pdfResource } from "@/helpers/constants";

type LinkType =
  | "application/pdf"
  // TODO: better define those
  | "application/xhtml+xml"
  | "application/xhtml+xml--FXL";

export class Media {
  constructor(private readonly manifest: Ref<Manifest | null>) {}

  public get isPDF(): boolean {
    return (
      this.conformsTo === "https://readium.org/webpub-manifest/profiles/pdf"
    );
  }

  public get isFXL(): boolean {
    return (
      this.epubLayout === "fixed" ||
      this.conformsTo === "https://readium.org/webpub-manifest/profiles/divina"
    );
  }

  public get isMediaOverlay(): boolean {
    return this.manifest.value?.readingOrder.items.some((item) => {
      return !!item.alternates?.findWithMediaType(mediaOverlayResource.name);
    });
  }

  public get isReflowable(): boolean {
    return !this.isFXL && !this.isPDF && !this.isMediaOverlay;
  }

  public get isFrog(): boolean {
    return this.conformsTo === "https://www.mobidys.com/format-frog/";
  }

  public get linkType(): LinkType | null {
    const manifest = this.manifest.value;
    if (!manifest) {
      return null;
    }

    if (this.isPDF) {
      return pdfResource.name;
    }

    let type = manifest.readingOrder.items.find(
      (item) => item.mediaType.isHTML
    )?.type;

    if (!type) return null;

    if (this.isFXL) {
      type += "--FXL";
    }

    return type as LinkType;
  }

  private get epubLayout(): string | null {
    return this.manifest.value?.metadata?.getPresentation()?.layout || null;
  }

  private get conformsTo(): string | null {
    const meta = this.manifest.value?.metadata?.otherMetadata;
    return (
      meta?.conformsTo || meta?.["http://purl.org/dc/terms/conformTo"] || null
    );
  }
}
